module.exports = __webpack_public_path__ + "static/media/qr-code.1863f20e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/qr-code.svg
// module id = 208
// module chunks = 0